module.exports = __webpack_public_path__ + "img/Kaelin.7d1bcf32.jpg";